import script from "./chatSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./chatSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./chatSidebar.vue?vue&type=style&index=0&id=c347a3da&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c347a3da"]])

export default __exports__